<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <h3>REPORTE VALORIZADO DE VUELTAS DE CAMION</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-primary btn-icon" @click="cargar_datos">
              <i class="fas fa-filter"></i> Filtrar
            </button>
            <button class="btn btn-success btn-icon" @click="exportar_excel">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <table class="table table-bordered">
              <tr class="background-light">
                <th>RANGO DE FECHAS</th>
                <th>PATENTE</th>
              </tr>
              <tr>
                <td>
                  <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true"
                    value-type="YYYY-MM-DD"></date-picker>
                <td style="padding: 0.5em">
                  <v-select class="" :reduce="(option) => option.id" v-model="transportes_id" :closeOnSelect="false"
                    :options="transportes" label="patente" multiple>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se Encontraron Resultados Para
                        <em>{{ search }}</em>.
                      </template>
                      <em style="opacity: 0.5" v-else>Escriba para Filtrar...</em>
                    </template>
                  </v-select>
                </td>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">

                  <tr>
                    <th colspan="13" class="fixed outlineado background-salmon-3 text-center"><span class="titulo_tabla_1">VUELTA</span></th>
                    <th colspan="5" class="fixed outlineado background-salmon-3 text-center"><span class="titulo_tabla_1">DETALLE TICKETS</span></th>
                    <th colspan="2" class="fixed outlineado background-salmon-3 text-center"><span class="titulo_tabla_1">DETALLE GUIAS</span></th>
                    <th colspan="2" class="fixed outlineado background-salmon-3 text-center"><span class="titulo_tabla_1">DETALLE DISTRIBUCIÓN</span></th>
                  </tr>
                  <tr>
                    <th
                      class="fixed-2 outlineado background-salmon-3 text-center"
                      v-for="c in columnas"
                      :key="c.label"
                      v-show="c.show"
                    >
                    <span class="titulo_tabla_1">{{c.label}}</span>
                    </th>
                  </tr>
                </thead>
                <tbody v-html="filitas">
                </tbody>
              </table>
            </div>
          </div>
        </div> -->

        <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">

                  <!-- <tr>
                    <th colspan="13" class="fixed outlineado background-salmon-3 text-center"><span
                        class="titulo_tabla_1">VUELTA</span></th>
                    <th colspan="5" class="fixed outlineado background-salmon-3 text-center"><span
                        class="titulo_tabla_1">DETALLE TICKETS</span></th>
                    <th colspan="2" class="fixed outlineado background-salmon-3 text-center"><span
                        class="titulo_tabla_1">DETALLE GUIAS</span></th>
                    <th colspan="2" class="fixed outlineado background-salmon-3 text-center"><span
                        class="titulo_tabla_1">DETALLE DISTRIBUCIÓN</span></th>
                  </tr> -->
                  <tr>
                    <th class="fixed outlineado background-salmon-3 text-center" v-for="c in columnas2" :key="c.label"
                      v-show="c.show">
                      <span class="titulo_tabla_1">{{ c.label }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody v-html="filitas2">
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    datos: [],
    transportes: [],
    transportes_id: [],
    todos: true,
    patente: [],
    columnas2: [
      {
        show: true,
        label: "Barco",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Muelle",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Guía Traslado",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Vuelta",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Patente",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Folio Trans. Ida",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Folio Trans. Vuelta",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Trans. Ida",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Trans. Vuelta",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Folio Almuerzo",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Folio Colacion",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Almuerzo",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Colacion",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Folio Lavado",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Lavado",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Ticket",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Fecha",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Materia Prima",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Peso Neto (KG)",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Guía",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Empresa",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Sucursal",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Informado (KG)",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Informado Prorrateo (KG)",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Recibido (KG)",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Producto",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Destino",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Cantidad (KG)",
        tipo: "string",
        path: "barco",
        ancho_excel: 22,
      },
    ],
    columnas: [
      {
        show: true,
        label: "Fecha Ingreso Portería",
        tipo: "datetime",
        path: "fecha_ingreso",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "N° Viaje",
        tipo: "string",
        path: "numero_viaje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Patente",
        tipo: "string",
        path: "patente",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tipo Calculo Kilometraje",
        tipo: "string",
        path: "tipo_kilometraje",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "Km Teórico",
        tipo: "string",
        path: "max_km_teorico",
        ancho_excel: 35,
      },
      {
        show: true,
        label: "Km Real",
        tipo: "string",
        path: "km_real",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Litros Petroleo Consumido",
        tipo: "string",
        path: "litros_viaje",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Rendimiento Petroleo",
        tipo: "string",
        path: "rendimiento_viaje",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Tarifa Transbordador Ida",
        tipo: "number",
        path: "tarifa_ida",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Transbordador Vuelta",
        tipo: "number",
        path: "tarifa_vuelta",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Lavado",
        tipo: "number",
        path: "tarifa_lavado",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Colacion",
        tipo: "number",
        path: "tarifa_colacion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Tarifa Arriendo",
        tipo: "number",
        path: "tarifa_arriendo",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Ticket",
        tipo: "string",
        path: "codigo_ticket",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Peso Neto (Kg)",
        tipo: "string",
        path: "peso_comercial_neto_corregido",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Cargo Transbordador",
        tipo: "number",
        path: "tarifa_transbordador",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Cargo Lavado",
        tipo: "number",
        path: "tarifa_lavado",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Cargo Colación",
        tipo: "number",
        path: "tarifa_colacion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Guía",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Peso Recibido (Kg)",
        tipo: "number",
        path: "peso_real",
        ancho_excel: 22,
      },

      {
        show: true,
        label: "Destino",
        tipo: "number",
        path: "destino_distribucion",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "Peso (Kg)",
        tipo: "number",
        path: "peso_real_distribucion",
        ancho_excel: 22,
      },

    ],
  }),
  mounted() {
    //this.cargar_datos();
    this.cargar_transportes();
  },
  methods: {
    async cargar_datos() {
      this.datos = [];
      this.url_excel = null;

      let loader = this.$loading.show({
        // Optional parameters
        //container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        color: "#262b63",
        backgroundColor: "#ededed",
        //onCancel: this.onCancel,
        loader: "spinner",
      });

      let body = {
        columnas: this.columnas
          .filter((c) => c.show == true)
          .map((c) => {
            return {
              cabecera: c.label,
              path: c.path,
              tipo: c.tipo,
              ancho_excel: c.ancho_excel,
            };
          }),
      };

      if (this.transportes_id.length > 0) {
        body.transportes_id = this.transportes_id;
      }

      // if(this.patente != null && this.patente != ""){
      //     body.patente = this.patente;
      // }

      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        body.desde = this.fechas[0];
        body.hasta = this.fechas[1];
      }

      console.log("body", body);
      await this.axios
        .post(`${this.api}/reportes/viajes`, body, this.cabeceras_json)
        .then((res) => {
          /* console.log("datoooooooos",res.data.data);
          this.datos = res.data.data.viajes;
          this.url_excel = res.data.data.url */
          console.log("datoooooooos", res.data);
          this.datos = res.data.items;
          this.url_excel = res.data.url
          loader.hide();
          //console.log("url_excel", this.url_excel);
        })
        .catch((e) => {
          console.log(e);
        });
      //}
    },

    async cargar_transportes() {
      await this.axios
        .get(`${this.api}/transportes?limit=99999`, this.cabeceras_json)
        .then((res) => {
          console.log("res", res.data.data);
          this.transportes = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      if (tipo_dato == "datetime") {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == "date") {
        valor = this.$options.filters.fecha(valor);
      }
      if (tipo_dato == "time") {
        valor = this.$options.filters.hora(valor);
      }
      return valor;
    },
    setearTodos() {
      this.columnas.forEach((c) => {
        c.show = this.todos;
      });
    },
    retornar_valor(item,path){
      return item[path]?item[path]:"";
    }
  },
  computed: {
    filitas2() {
      let filitas = "";
      let clase = "";
      let intercalar = false;
      let fv = "";
      let ft = "";
      let fg = "";
      this.datos.forEach(fila => {
        if (intercalar == true) {
          clase = "cebrita";
        } else {
          clase = "";
        }
        intercalar = !intercalar;

        fv = `
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila,'barco')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila,'muelle')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila,'guia_traslado')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${fila.viajes[0].ingreso_vehiculos_porteria_id}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${fila.viajes[0].patente}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila.viajes[0],'folio_trans_ida')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila.viajes[0],'folio_trans_vuelta')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles2(this.retornar_valor(fila.viajes[0],'tarifa_ida'))}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles2(this.retornar_valor(fila.viajes[0],'tarifa_vuelta'))}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila.viajes[0],'folios_almuerzo')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila.viajes[0],'folios_colacion')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles2(this.retornar_valor(fila.viajes[0],'total_tarifa_almuerzo'))}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles2(this.retornar_valor(fila.viajes[0],'total_tarifa_colacion'))}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.retornar_valor(fila.viajes[0],'folio_lavado')}</td>
                <td rowspan="${fila.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles2(this.retornar_valor(fila.viajes[0],'tarifa_lavado'))}</td>
                `;

        fila.viajes[0].tickets.forEach(async (t, i) => {
          ft = `
              <td rowspan="${t.num_rows}" class="${clase} centrado">${t.codigo_ticket}</td>
              <td rowspan="${t.num_rows}" class="${clase} centrado">${this.$options.filters.fecha_hora(t.fecha_hora_ticket)}</td>
              <td rowspan="${t.num_rows}" class="${clase} centrado">${t.materia_prima}</td>
              <td rowspan="${t.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles(t.peso_comercial_neto_corregido)}</td>`;

          if (i > 0) {
            fv = "";
          }

          await t.guias.forEach(async (g, id) => {
            //console.log('dists '+g.distribuciones.length,t.codigo_ticket,g.numero_guia);

            fg = `
              <td rowspan="${g.num_rows}" class="${clase} centrado">${g.numero_guia}</td>
              <td rowspan="${g.num_rows}" class="${clase} centrado">${g.empresa}</td>
              <td rowspan="${g.num_rows}" class="${clase} centrado">${g.sucursal}</td>
              <td rowspan="${g.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_informado)}</td>
              <td rowspan="${g.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_informado_prorrateo)}</td>
              <td rowspan="${g.num_rows}" class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_real)}</td>`;

            if (id > 0) {
              ft = "";
              fv = "";
              //fg = "";
            }

            await g.distribuciones.forEach((d, idx) => {

              if (idx > 0) {
                ft = "";
                fv = "";
                fg = "";
              }

              filitas += `<tr>
                ${fv}
                ${ft}
                ${fg}
                <td class="${clase} centrado">${d.producto_recibido}</td>
                <td class="${clase} centrado">${d.destino}</td>
                <td class="${clase} centrado">${this.$options.filters.formatear_miles(d.peso_real)}</td>
                </tr>`;

            });
            //filitas+=`<tr>${fv}${ft}<td class="${clase} centrado">${g.numero_guia}</td><td class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_real)}</td></tr>`;

          });

        });

      })
      return filitas;
    },
    filitas() {
      let filitas = "";
      //let arr = [];
      let primera_fila = true;
      let intercalar = false;
      let clase = "";
      let fv = "";
      let ft = "";
      let fg = "";
      this.datos.forEach(async (viaje, idx) => {
        if (intercalar == true) {
          clase = "cebrita";
        } else {
          clase = "";
        }
        intercalar = !intercalar;
        fv = `
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.fecha_hora(viaje.fecha_ingreso)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${viaje.numero_viaje}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${viaje.patente}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${viaje.tipo_kilometraje ? viaje.tipo_kilometraje : ""}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.max_km_teorico)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.km_real)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${viaje.litros_viaje ? viaje.litros_viaje : ""}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${viaje.rendimiento_viaje ? viaje.rendimiento_viaje : ""}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.tarifa_ida)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.tarifa_vuelta)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.tarifa_lavado)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.tarifa_colacion)}</td>
                <td rowspan="${viaje.cantidad_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(viaje.tarifa_arriendo)}</td>`;

        await viaje.tickets.forEach(async (t, i) => {
          ft = `<td rowspan="${t.total_distribuciones}" class="${clase} centrado">${t.codigo_ticket}</td>
                        <td rowspan="${t.total_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(t.peso_comercial_neto_corregido)}</td>
                        <td rowspan="${t.total_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(t.tarifa_transbordador)}</td>
                        <td rowspan="${t.total_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(t.tarifa_lavado)}</td>
                        <td rowspan="${t.total_distribuciones}" class="${clase} centrado">${this.$options.filters.formatear_miles(t.tarifa_colacion)}</td>`;

          if (i > 0) {
            fv = "";
          }

          await t.guias.forEach(async (g, id) => {
            //console.log('dists '+g.distribuciones.length,t.codigo_ticket,g.numero_guia);

            fg = `<td rowspan="${g.distribuciones.length}" class="${clase} centrado">${g.numero_guia}</td>
                          <td rowspan="${g.distribuciones.length}" class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_real)}</td>`;

            if (id > 0) {
              ft = "";
              fv = "";
              //fg = "";
            }

            await g.distribuciones.forEach((d, idx) => {

              if (idx > 0) {
                ft = "";
                fv = "";
                fg = "";
              }

              filitas += `<tr>${fv}${ft}${fg}<td class="${clase} centrado">${d.destino_distribucion}</td><td class="${clase} centrado">${this.$options.filters.formatear_miles(d.peso_real_distribucion)}</td></tr>`;

            });
            //filitas+=`<tr>${fv}${ft}<td class="${clase} centrado">${g.numero_guia}</td><td class="${clase} centrado">${this.$options.filters.formatear_miles(g.peso_real)}</td></tr>`;

          });

        });


      });
      return filitas;
    },
    ...mapState(['api', 'api_public', 'cabeceras_json', 'token'])
  }
};
</script>
<style>
.tableFixHead {
  overflow: auto;
  height: 600px;
  border: 1px solid rgb(101, 101, 101);
}

/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 46px;
}

.fixed-2 {
  position: sticky;
  top: 46px;
  z-index: 10;
}

.outlineado {
  outline: 1px solid rgb(17, 15, 15);
}

/* Just common table stuff. Really. */
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 8px 16px;
}

/*th     { background:#427391; color:#fff }*/
.margen-1 {
  margin: 0em 0.5em;
}

.cebrita {
  background-color: #f2f2f2 !important;
}

.centrado {
  text-align: center !important;
  vertical-align: middle !important;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #afafaf;
}
</style>